import React from 'react'
import { GoAlert } from "react-icons/go";

const ConfigErrorComponent = ({ errorHeader, errorLine1 = '', errorLine2 = '', errorLine3 = '' }) => {
    return (
        <div className='d-flex justify-content-center align-items-center' style={{ minHeight: 'calc(100vh - 200px)' }}>
            <div className="container" style={{ fontSize: '20px' }}>
                <div className="row">
                    <div className="col-8">
                        <div className='row d-flex flex-column'>
                            <h1 className='mb-3'>{errorHeader}</h1>
                            <span>{errorLine1}</span>
                            <span>{errorLine2}</span>
                            <span>{errorLine3}</span>
                        </div>
                    </div>
                    <div className="col text-center">
                        <GoAlert size={200} className='error-text-color' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConfigErrorComponent